import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { poplarBluffMOConfig } from "./data";

export default function PoplarBluffMOPage() {
  return <CityPageTemplate config={poplarBluffMOConfig} />;
}